export const VARIABLE_REFERENCE_PREFIX = 'var:';
export const VARIABLE_PATH_SEPARATOR_TOKEN_ATTRIBUTE = '|';
export const VARIABLE_PATH_SEPARATOR_TOKEN_STYLE = '--';
